import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiResponse } from '../models/api-response.model';
import { Attachment } from '../models/attachment';
import { BaseService } from './base-service';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }
  upload(file: FormData): Observable<ApiResponse<any>> {
    return this.http
      .post<ApiResponse<any>>(`/api/Attachment/Upload/`, file)
      .pipe(catchError(this.handleError));
  }

  download(id: string): Observable<Blob> {
    return this.http.get(`Attachment/Download/${id}`, { responseType: 'blob' })
      .pipe(catchError(this.handleError));
  }

  deleteAttachment(id: string) {
    return this.http
      .get(`Attachment/DeleteAttachment?id=${id}`)
      .pipe(catchError(this.handleError));
  }

  get(id: string): Observable<ApiResponse<Attachment>> {
    return this.http.get<ApiResponse<Attachment>>(
      'Attachment/GetAttachment?id=' + id
    );
  }

  getByIds(ids: string[]): Observable<ApiResponse<Attachment[]>> {
    return this.http.post<ApiResponse<Attachment[]>>(
      'Attachment/GetByIds', ids);
  }

  post(
    file: File,
    title: string,
  ) {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('title',title);
    return this.http.post<ApiResponse<string>>(
      'Attachment/CreateAttachment',
      formData
    );
  }
}
